<div
  [class]="
    twMerge([
      'tw-group tw-relative tw-block',
      selectedItems.length ? 'has-selection' : '',
    ])
  "
>
  <button
    type="button"
    [cdkMenuTriggerFor]="context_menu"
    [attr.aria-disabled]="disabled"
    [attr.aria-labelledby]="!iconOnly ? ariaLabelledbyClasses : ''"
    [attr.aria-describedby]="ariaDescribedby"
    data-dgat="'dropdown-target-button'"
    [class]="
      twMerge(
        [
          'tw-btn-secondary-outline group-[.has-error]:tw-text-red-800 group-[.has-error]:tw-ring-red-800',
        ],
        className,
        disabled ? 'focus:tw-outline-none' : ''
      )
    "
  >
    <!-- hiding selection value in action mode where selection is not important-->
    @if (!isActionMenu) {
      <span
        [id]="'da-dropdown-value-' + uid"
        [class]="
          iconOnly
            ? 'tw-sr-only'
            : selectedItems.length > 1 && showInitialSelectionWithMultiSelect
              ? className
              : ''
        "
      >
        @switch (selectedItems.length) {
          @case (0) {
            <span>{{ placeholder }}</span>
          }
          @case (1) {
            {{ selectedItems[0]?.name }}
            @if (
              selectedItems[0]?.secondaryName && showSecondaryNameOnSelection
            ) {
              <span> &bull; {{ selectedItems[0]?.secondaryName }} </span>
            }
          }
          @default {
            @if (
              selectedItems.length > 1 && showInitialSelectionWithMultiSelect
            ) {
              <span> {{ selectedItems[0]?.name }}</span>
              +{{ selectedItems.length - 1 }}
            } @else {
              +{{ selectedItems.length }}
            }
          }
        }
      </span>
    }

    <da-icon
      [attr.aria-label]="iconAriaLabel"
      [icon]="iconName"
      class="tw-size-4"
    ></da-icon>
  </button>
  @if (showLabel) {
    <label
      [id]="'da-dropdown-label-' + uid"
      [class]="
        'tw-absolute tw-hidden tw-origin-[0] tw-transform tw-cursor-text tw-rounded-sm tw-bg-white tw-p-[2px] tw-text-xs tw-text-neutral-600 tw-duration-300 group-hover:tw-text-neutral-800 group-[.has-selection]:-tw-top-3 group-[.has-selection]:tw-left-2 group-[.has-selection]:tw-inline-block group-[.has-error]:tw-text-red-800 group-hover:group-[.has-error]:tw-text-red-800'
      "
    >
      {{ placeholder }}
    </label>
  }
</div>

<ng-template #context_menu>
  <div cdkMenu>
    @if (!disabled) {
      <ul
        class="tw-reset tw-flex tw-max-h-80 tw-min-w-60 tw-origin-top tw-flex-col tw-overflow-y-auto tw-rounded-lg tw-bg-white tw-py-2 tw-shadow-xl tw-ring-1 tw-ring-neutral-200 tw-transition"
        [id]="'da-dropdown-menu-id' + uid"
      >
        @for (item of items; track item.id) {
          <li>
            <button
              cdkMenuItem
              type="button"
              [class]="
                twMerge(
                  'tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-px-4 tw-py-2 tw-text-left !tw-text-[16px]  !tw-text-neutral-800 hover:tw-bg-neutral-100 focus-visible:tw-outline-none',
                  disabled || item?.disabled
                    ? 'tw-cursor-not-allowed tw-opacity-50'
                    : 'hover:tw-bg-neutral-100'
                )
              "
              [attr.aria-disabled]="item?.disabled"
              [attr.data-dgat]="'dropdown-list-item-' + item?.id"
              (cdkMenuItemTriggered)="handleItemSelect(item)"
              (click)="handleItemClicked(item)"
            >
              <div
                class="pr-10 text-left tw-leading-5"
                [class]="
                  twJoin(
                    isItemSelected(item.id) ? 'tw-font-semibold' : '',
                    item?.className
                  )
                "
              >
                <span
                  class="tw-block tw-max-w-48 tw-truncate"
                  title="{{ item.name }}"
                >
                  <span class="tw-flex tw-items-center tw-gap-x-2">
                    @if (item.iconName) {
                      <da-icon
                        icon="{{ item.iconName }}"
                        className="tw-size-4"
                      ></da-icon>
                    }
                    {{ item.name }}
                  </span>
                </span>
                <span class="tw-text-xs tw-text-neutral-600">
                  {{ item?.secondaryName }}
                </span>
              </div>

              <div class="tw-flex tw-items-center tw-gap-3">
                @if (item?.badgeLabel) {
                  <span
                    class="tw-rounded-2xl tw-border tw-border-purple-300 tw-bg-purple-50 tw-px-2 tw-py-1 tw-text-xs tw-font-extrabold tw-uppercase tw-text-purple-800"
                  >
                    {{ item.badgeLabel }}
                  </span>
                }
                @if (isItemSelected(item.id) && !multiSelect) {
                  <da-icon
                    icon="check-circle"
                    type="solid"
                    class="tw-size-5 tw-text-green-600"
                  ></da-icon>
                }
              </div>
              @if (multiSelect) {
                <input
                  class="tw-ml-2 tw-size-4 tw-rounded tw-border-neutral-400 tw-text-right tw-text-blue-700"
                  type="checkbox"
                  [checked]="isItemSelected(item.id)"
                />
              }
            </button>
          </li>
        }
      </ul>
    }
  </div>
</ng-template>
